import s from './LiquidLoader.module.css';

/**
 * Loader da marca: o símbolo da Apen enchendo de líquido.
 *
 * Substitui o `<div className="app-loading">` que existia antes e que nunca
 * apareceu — a classe nunca chegou a ter CSS, então o elemento tinha altura
 * zero e a tela ficava simplesmente branca durante o carregamento.
 *
 * `fixo` cobre a janela inteira (troca de rota, antes de existir shell);
 * sem ele, cobre o container posicionado mais próximo — a área de conteúdo
 * do painel, deixando a navegação visível e clicável.
 */
export function LiquidLoader({
  fixo = false,
  rotulo = 'Carregando',
}: {
  fixo?: boolean;
  rotulo?: string | null;
}) {
  return (
    <div
      className={`${s.overlay} ${fixo ? s.overlayFixo : ''}`}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className={s.marca} aria-hidden="true">
        <div className={`${s.onda} ${s.ondaTras}`} />
        <div className={`${s.onda} ${s.ondaFrente}`} />
      </div>
      {rotulo ? <div className={s.rotulo}>{rotulo}</div> : null}
      <span style={{ position: 'absolute', width: 1, height: 1, overflow: 'hidden', clip: 'rect(0 0 0 0)' }}>
        {rotulo ?? 'Carregando'}
      </span>
    </div>
  );
}
